import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LogIn } from 'lucide-react'
import { useAdminAuth } from '../hooks/useAdminAuth.js'
import CarFileLogo from '../components/CarFileLogo.jsx'

const Login = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAdminAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <CarFileLogo size="xl" dark />
          </div>
          <h1 className="text-2xl font-bold text-white">Admin Panel</h1>
          <p className="text-gray-400 mt-1">Sign in to manage your platform</p>
        </div>

        <button
          onClick={() => loginWithRedirect()}
          className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold rounded-xl hover:shadow-lg hover:shadow-purple-500/25 transition-all duration-200"
        >
          <LogIn className="w-5 h-5" />
          Sign in with Auth0
        </button>

        <p className="text-center text-gray-500 text-sm mt-6">
          Only administrators can access this panel
        </p>
      </div>
    </div>
  )
}

export default Login
